import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface KitLogo {
  id: string;
  logo_id: string;
  is_active: boolean;
  storage_path: string | null;
}

export function useKitLogo(kitId: string | null) {
  const { data: kitLogo, isLoading, error } = useQuery<KitLogo | null>({
    queryKey: ['kit-logo', kitId],
    queryFn: async () => {
      if (!kitId) return null;
      
      const { data, error } = await supabase
        .from('kit_logos')
        .select(`
          id,
          logo_id,
          is_active,
          logos:logo_id (
            storage_path
          )
        `)
        .eq('kit_id', kitId)
        .eq('is_active', true)
        .maybeSingle();
      
      if (error) {
        console.error('Error fetching kit logo:', error);
        return null;
      }
      
      // If no data or no logo, return null
      if (!data) return null;
      
      // Extract the logo storage path
      const logoStoragePath = data.logos?.storage_path || null;
      
      // Transform the response into our KitLogo type
      return {
        id: data.id,
        logo_id: data.logo_id,
        is_active: data.is_active,
        storage_path: logoStoragePath,
      };
    },
    enabled: !!kitId,
  });

  return { kitLogo, isLoading, error };
}
